// extracted by mini-css-extract-plugin
module.exports = {"container":"CourseContentLayout_container__sIRIf","mainContent":"CourseContentLayout_mainContent__hnOeT","sidebar":"CourseContentLayout_sidebar__SkmqZ"};